import {createApp} from "vue";
import InstagramFeed from "./InstagramFeed.vue";

export var initTmcInstFeed = function(element){
    createApp({
        components: {
            InstagramFeed
        }
    }).mount(element);
}

window.initTmcInstFeed = initTmcInstFeed;